<div class="loader-wrap" fxLayout="column" fxLayoutAlign="center center">
    <div style="opacity: 1">
        <mat-progress-spinner
            [color]="'primary'"
            [mode]="'indeterminate'"
            [value]="25"
            [strokeWidth]="5">
        </mat-progress-spinner>
    </div>
</div>